// ICountry
import { ICountry } from '../types/country'

interface IRegion {
    countryId: string
    id: string
    label: string
}

export interface IConstructedRegionCountry {
    label: string | undefined
    regions: IRegion[]
}

export class RegionData {
    regions: IRegion[]
    countries: ICountry[]
    constructedRegionCountries: IConstructedRegionCountry[]
    constructor(regions: IRegion[], countries: ICountry[]) {
        if (!regions) throw new Error('regions are mandatory in RegionData')
        if (!countries) throw new Error('countries are mandatory in RegionData')
        this.regions = regions
        this.countries = countries
        this.constructedRegionCountries = this.constructRegionsMap()
    }

    private constructRegionsMap(): IConstructedRegionCountry[] {
        const countryIds = new Set(this.regions.map((region) => region.countryId))
        const groupedRegionsByCountry = []

        for (const countryId of countryIds) {
            const foundCountry = this.countries.find((country) => country.id === countryId)
            const groupedRegions = {
                label: foundCountry?.label,
                regions: this.regions.filter((region) => region.countryId === countryId)
            }
            groupedRegionsByCountry.push(groupedRegions)
        }
        return groupedRegionsByCountry
    }
}
